import "./loading.scss"
function Loading() {

  return (
    <div className="o-pokeball c-loader u-bounce">
    </div>
  );
}

export default Loading;